<template>
  <!--  <router-link :to="{name: 'catalog'}" v-slot="{href}">-->
  <div class="border border-1 border-custom-gray rounded-3 cursor-pointer" @click="clickAction">
    <div style="margin-top: 15px;"></div>
    <div class="bg-custom-bg-color" style="width: 150px; height: 150px; margin: 0 auto">
      <div class="fit center-xy" style="width: 150px; height: 150px;" v-if="isEmpty(item.Cover)">
        <EmptyImage :size=18></EmptyImage>
      </div>
      <img v-else
           class="fit center-xy"
           style="width: 150px; height: 150px;"
           :src="getMediaUrl(item.Cover)" rel="nofollow">
    </div>
    <div style="margin-top: 12px"></div>
    <p class="m-0 text-center">{{ item.name }}</p>
  </div>
  <!--  </router-link>-->
</template>

<script>
import {getMediaUrl, isEmpty} from "@/util/helpers";
import EmptyImage from "@/components/EmptyImage.vue";

export default {
  name: "brand_item",
  components: {EmptyImage},
  props: {
    item: Object,
    // name: {
    //   type: String,
    //   default: ""
    // },
    // img: {
    //   type: String,
    //   default: ""
    // },
    // src: {
    //   type: String,
    //   default: ""
    // },
  },
  methods: {
    isEmpty,
    getMediaUrl: getMediaUrl,
    clickAction() {
      this.$router.push({ name: 'latest', query: { commodity_brand_id: this.item.id } });
    }
  }
}
</script>

<style scoped>
.fit {
  object-fit: cover;
}
</style>
